import React, {useEffect, useState} from 'react'
import {Card, Icon, Image, Input, Menu, Segment} from 'semantic-ui-react'
import moment from "moment";
import {fetchCourses} from "../../../../../redux/actions/CoursesActions";
import {CourseForm} from "../CourseForm";
import {useHistory} from "react-router";

const CourseCard = ({course}) => {

    const history = useHistory();
    const link = `/place/courses/${course.id}/${course.slug}`;
    const cover = course.cover ? course.path + course.cover : false;

    return (
        <Card
            color={'red'}
            onClick={() => history.push(link)}
        >
            <Image
                src={cover || 'https://img-a.udemycdn.com/course/240x135/1586752_2d9e_2.jpg'}
                wrapped
                ui={false}
            />
            <Card.Content>
                <Card.Meta>
                    {/*<span className='date'>{moment(course.created_at).format('DD/MM/YYYY HH:mm')}</span>*/}
                    {course.course_category.name}
                </Card.Meta>
                <Card.Header>{course.name}</Card.Header>
                {/*<Card.Description content={course.description}/>*/}
            </Card.Content>
            <Card.Content extra>
                    <Icon name='user'/>
                {course.people_counter} pessoas inscritas
            </Card.Content>
        </Card>
    )
}

const NavBar = ({setShowForm}) => {
    return (
        <Menu secondary>
            <Menu.Item
                onClick={() => setShowForm(true)}
                content={'Criar curso'}
            >
            </Menu.Item>
            <Menu.Menu position='right'>
                <Menu.Item>
                    <Input icon='search' placeholder='Search...'/>
                </Menu.Item>
            </Menu.Menu>
        </Menu>
    );
}

export const Main = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('');
    const [courses, setCourses] = useState([])
    const [showForm, setShowForm] = useState(false)
    const {place_id} = JSON.parse(sessionStorage.getItem('Data'))

    const fetchData = async () => {
        // start loading
        setLoading(true);

        try {
            // get posts
            const result = await fetchCourses({place_id, product: 0});

            // set posts
            setCourses(result.data);

        } catch (e) {
            // show errors
            console.log('error', e);
        } finally {
            // stop loading
            setLoading(false);
        }
    };

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        fetchData();
    }, []);

    const handleSuccess = async ({id, slug}) => {
        history.push(`/place/courses/${id}/${slug}`);
    }

    return (
        <React.Fragment>

            <NavBar setShowForm={setShowForm}/>

            <CourseForm show={showForm} onCancel={() => setShowForm(false)} onSuccess={handleSuccess}/>

            <Segment basic style={{padding: 0, minHeight: 320}} loading={loading}>
                <Card.Group itemsPerRow={4}>
                    {
                        courses.map((course) => <CourseCard key={`course-${course.id}`} course={course}/>)
                    }
                </Card.Group>
            </Segment>
        </React.Fragment>
    )
}